import httpClient from "./httpClient";
import { VacancyType, Listing } from "../types/listings";

const END_POINT = "/listings";

const getListing = async (id: number): Promise<Listing | undefined> => {
	const response = await httpClient.get(`${END_POINT}/${id}`);
	return response.data as Listing;
};

const putVacancyType = async (
	listingid: number,
	vacancy: VacancyType
): Promise<VacancyType | undefined> => {
	const response = await httpClient.put(
		`${END_POINT}/${listingid}/vacancytypes/${vacancy.id}`,
		vacancy
	);
	return response.data as VacancyType;
};

const getListingsShort = async (): Promise<Listing[] | undefined> => {
	const response = await httpClient.get(`${END_POINT}/short`);
	return response.data as Listing[];
};

export { putVacancyType, getListing, getListingsShort };
